/**
 * Домен: справочник, шаблоны комплектов, смета, акт.
 *
 * Это те самые «позиция → шаблон комплекта» из ТЗ. Ключевая идея —
 * у каждой строки справочника ДВЕ цены: за материал и за работу.
 * Кабель тогда перестаёт быть особым случаем: «цена за метр (материал)»
 * и «цена за метр (прокладка)» — это просто materialPrice и laborPrice
 * одной и той же позиции с единицей измерения «м».
 */
// ─────────────────────────────────────────────────────────────
// Справочники
// ─────────────────────────────────────────────────────────────
export const UNITS = ['PCS', 'M', 'SET', 'HOUR'];
export const UNIT_LABELS = {
    PCS: 'шт.',
    M: 'м',
    SET: 'компл.',
    HOUR: 'ч',
};
export const ITEM_KINDS = ['EQUIPMENT', 'MATERIAL', 'LABOR', 'CABLE'];
export const ITEM_KIND_LABELS = {
    EQUIPMENT: 'Оборудование',
    MATERIAL: 'Материал',
    LABOR: 'Работа',
    CABLE: 'Кабель',
};
// ─────────────────────────────────────────────────────────────
// Шаблоны комплектов
// ─────────────────────────────────────────────────────────────
export const QTY_MODES = ['PER_ROOT', 'FIXED'];
// ─────────────────────────────────────────────────────────────
// Смета
// ─────────────────────────────────────────────────────────────
export const ESTIMATE_MODES = ['EXPRESS', 'DETAILED'];
export const ESTIMATE_STATUSES = ['DRAFT', 'SENT', 'APPROVED', 'REJECTED', 'ARCHIVED'];
export const VAT_MODES = ['NONE', 'ADDED', 'INCLUDED'];
// ─────────────────────────────────────────────────────────────
// Акт выполненных работ
// ─────────────────────────────────────────────────────────────
export const ACT_STATUSES = ['OPEN', 'IN_PROGRESS', 'DONE', 'SENT'];
// ─────────────────────────────────────────────────────────────
// Пользователи и права
// ─────────────────────────────────────────────────────────────
export const ROLES = ['ADMIN', 'MANAGER', 'INSTALLER'];
export const ROLE_LABELS = {
    ADMIN: 'Администратор',
    MANAGER: 'Менеджер',
    INSTALLER: 'Монтажник',
};
/**
 * Что кому можно. Держим таблицей, а не россыпью if-ов по коду:
 * права легко проверить глазами и легко покрыть тестом.
 *
 * Главное здесь — costPrice:read. Монтажник видит смету объекта, но
 * закупочные цены ему не показываются никогда.
 */
export const PERMISSIONS = {
    ADMIN: [
        'catalog:read', 'catalog:write',
        'kit:read', 'kit:write',
        'estimate:read', 'estimate:write', 'estimate:delete',
        'act:read', 'act:write',
        'costPrice:read',
        'user:read', 'user:write',
        'company:write',
    ],
    MANAGER: [
        'catalog:read',
        'kit:read',
        'estimate:read', 'estimate:write',
        'act:read', 'act:write',
        'costPrice:read',
    ],
    INSTALLER: [
        'catalog:read',
        'kit:read',
        'estimate:read',
        'act:read', 'act:write',
    ],
};
export function can(role, permission) {
    return PERMISSIONS[role].includes(permission);
}
//# sourceMappingURL=domain.js.map